import React from "react";
import { Marker } from "react-leaflet";
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocationWithUserPic from "../LocationWithUserPic";
import {colorByScore} from "../../utils";

export default class CustomMarker extends React.Component {
    getMarkerColor = (score) => {    
        return colorByScore(this.props.location.currentScore)
    }

    generateMarkerContent = () => {
        return (
            <div className="LocationOn" style={{ color: this.getMarkerColor(), filter: 'drop-shadow(1px 1px 1px #444)' }}>
                {this.props.showUserPic ?
                    <LocationWithUserPic photoURL={this.props.location.lastReport.user.photoURL} fontSize='5rem' />
                    : <LocationOnIcon style={{fontSize:'4rem'}}/>}
            </div>
        );
    };

    render() {
        const icon = divIcon({
            className: "my-custom-icon",
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            html: renderToStaticMarkup(this.generateMarkerContent())
        });

        return (
            <Marker {...this.props} icon={icon} onClick={this.props.onLocationClicked}>{this.props.children}</Marker>
        )
    }
}